import { COUNTRY_CODE_OPTIONS } from "@/src/common/business-layer/constants"
import {
  DialingCodeSelectOption,
  SelectOption,
  SimpleSelect
} from "@/src/common/components/Select"
import { OptionProps, components } from "react-select"

const DialingCodeOption = (
  props: OptionProps<DialingCodeSelectOption, false>
) => {
  const { flag, label, name } = props.data
  return (
    <components.Option {...props}>
      <div className={"flex gap-4"}>
        {flag} <span className={"grow truncate max-w-[200px]"}>{name}</span>{" "}
        <span className="text-gray-400">{label}</span>
      </div>
    </components.Option>
  )
}

type DialingCodeSelectProps = {
  value: string
  onChange: (dialingCode: string) => void
  placeholder?: string
  hasError?: boolean
  className?: string
  classNames?: Record<string, () => string>
}

const DialingCodeSelect = ({
  value,
  onChange,
  placeholder = "Country code...",
  hasError = false,
  className = "pl-3.5",
  classNames
}: DialingCodeSelectProps) => (
  <SimpleSelect<DialingCodeSelectOption, false>
    name="dialingCode"
    aria-label="Country code"
    placeholder={placeholder}
    isSearchable={false}
    required
    filterOption={(
      option: { data: { name: string }; label: string },
      searchString: string
    ) => {
      const _searchString = searchString.toLowerCase().trim()
      return (
        option.data.name.toLowerCase().includes(_searchString) ||
        option.label.toLowerCase().includes(_searchString)
      )
    }}
    removeInputBorder={true}
    components={{ Option: DialingCodeOption }}
    value={
      (value
        ? { value, label: value }
        : "") as unknown as DialingCodeSelectOption
    }
    onChange={(selectedOption: SelectOption) => onChange(selectedOption.value)}
    options={COUNTRY_CODE_OPTIONS}
    className={`${
      hasError ? "border-stears_danger border-r-0" : ""
    } ${className}`}
    {...(classNames ? { classNames } : {})}
  />
)

export default DialingCodeSelect
